export default "__VITE_ASSET__B79vJtbc__"